import { Component } from '@angular/core';

import { MapService } from '../../../services/map.service';

@Component({
  selector: 'app-street-light-planner-step2-manual',
  templateUrl: './street-light-planner-step2-manual.component.html',
  styleUrls: [],
})
export class StreetLightPlannerStep2ManualComponent {
  constructor(private mapService: MapService) {
    this.mapService.selectMode(true);
  }
}
